// src/components/portfolio/add-asset/services/TefasService.js
 

// src/components/portfolio/add-asset/services/TefasService.js

export class TefasService {
    static fundListCache = null;
    static lastFetchTime = null;
    static CACHE_DURATION = 1000 * 60 * 60; // 1 saat
  
    // Cloud Run URL
    static API_URL = 'https://tefasservice-udthcqypiq-uc.a.run.app';
  
    static async getFundList() {
      // Cache kontrolü
      const now = Date.now();
      if (this.fundListCache && this.lastFetchTime && 
          (now - this.lastFetchTime < this.CACHE_DURATION)) {
        console.log('Cache kullanılıyor');
        return this.fundListCache;
      }
  
      try {
        console.log('Fonlar getiriliyor:', `${this.API_URL}/funds`);
        const response = await fetch(`${this.API_URL}/funds`);
        
        if (!response.ok) {
          throw new Error('Fon listesi alınamadı');
        }
  
        const result = await response.json();
        console.log('API yanıtı:', result);
        
        if (!result.success) {
          throw new Error(result.error || 'Fon listesi alınamadı');
        }
  
        // Cache'i güncelle
        this.fundListCache = result.data;
        this.lastFetchTime = now;
  
        console.log(`${result.data.length} fon alındı`);
        return result.data;
      } catch (error) {
        console.error('TEFAS fon listesi hatası:', error);
        return this.fundListCache || [];
      }
    }
  
    static async searchFunds(query) {
      if (!query || query.length < 2) return [];
  
      try {
        console.log('Fon araması yapılıyor:', query);
        const response = await fetch(
          `${this.API_URL}/funds/search?query=${encodeURIComponent(query)}`
        );
  
        if (!response.ok) {
          throw new Error('Arama yapılamadı');
        }
  
        const result = await response.json();
        console.log('Arama sonuçları:', result);
        
        if (!result.success) {
          throw new Error(result.error || 'Arama yapılamadı');
        }
  
        return result.data;
      } catch (error) {
        console.error('TEFAS arama hatası:', error);
        return [];
      }
    }
  }